import styled from "styled-components";

export const StyledCollaboratorDetail = styled.div`
  display: flex;
  flex-direction: column;

  & .select-container {
    width: 90px;
  }
`;

export const StyledSelectYearContainer = styled.div`
  width: 90px;
`;

export const StyledTabContainer = styled.div`
  display: flex;
  height: calc(100dvh - 138px);
  & > div:first-child {
    z-index: 2;
  }

  & .message-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }
`;

export const StyledExpandMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  min-width: 0;
  min-height: 0;
`;

export const StyledProfessionalHistoryBody = styled.div`
  width: 100%;
`;
